import Carga from '@/model/resource/Carga'
import CargaCsvSimplesSemTipoFinalizacaoSucessoSchema from '@/schema/CargaCsvSimplesSemTipoFinalizacaoSucesso.schema'

export default class CargaCsvSimplesSemTipoFinalizacaoSucesso extends Carga {

    get $schema() {
        return CargaCsvSimplesSemTipoFinalizacaoSucessoSchema(this)
    }

}
